import { render } from "./w8ben.vue?vue&type=template&id=48b6f522"
import script from "./w8ben.vue?vue&type=script&lang=js"
export * from "./w8ben.vue?vue&type=script&lang=js"

import "./w8ben.vue?vue&type=style&index=0&id=48b6f522&lang=less"
script.render = render

export default script